import apiClient from "../common/apiClient";

export default class DonationFeeController {
  async GetGridData(token) {
    try {
      return await apiClient.get("/getGridData", {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async CreateDonation(data, token) {
    try {
      return await apiClient.post("/generateDonationReceipt", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async GetDonationById(id, token) {
    try {
      return await apiClient.get("/getDonationById/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async SendPDFMail(id, token) {
    try {
      return await apiClient.get("/donationMailReceipt/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async DeleteDonationDataById(id, token) {
    try {
      return await apiClient.delete("/deleteDonation/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async GetMemberData(data, token) {
    try {
      return await apiClient.get("/getMemberDetailsDonation/" + data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  
}
